import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AttendanceStartCard from '../components/AttendanceStartCard';
import { ManualAttendanceQuick } from '../components/ManualAttendancePanel';
// リアルタイム出席はこのページにまとめた【2026-11-02】。受付中の回があるときだけ一番上に出す
import LiveAttendancePanel, { buildLiveItems } from '../components/LiveAttendancePanel';

export default function OtpGenerate({ user }) {
  const [classes, setClasses] = useState([]);
  // 「手動で出席を記録」の授業。ダッシュボードから ?manualClass=授業ID#manual で来たら、その授業にする【2026-10-13】
  //   そのときは、出席受付のカードが最初に選ぶ授業では上書きしない（先生がカードで選び直したら、そちらに合わせる）
  const location = useLocation();
  const fromLink = new URLSearchParams(location.search).get('manualClass') || '';
  const [startClassId, setStartClassId] = useState(fromLink);
  const locked = useRef(!!fromLink);
  const onStartClass = (id, byUser) => {
    if (locked.current && !byUser) return;
    locked.current = false;
    setStartClassId(id);
  };
  // 受付中の回・有効なコード（出席受付のカードが 10 秒ごとに拾い直して渡してくる）
  const [active, setActive] = useState({ sessions: [], otps: [] });
  const liveItems = buildLiveItems(active.sessions, active.otps);
  const manualRef = useRef(null);
  useEffect(() => {
    if (location.hash !== '#manual') return undefined;
    // 出席受付のカードが読み込まれて高さが決まってから動かす
    const t = setTimeout(() => {
      if (manualRef.current) manualRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 600);
    return () => clearTimeout(t);
  }, [location.hash, location.search]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch('/api/schedule/classes', { headers: { Authorization: 'Bearer ' + token } })
      .then(r => r.json())
      .then(d => setClasses(d.classes || d.data || []))
      .catch(() => {});
  }, []);

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>出席受付</h1>
        <p>授業を選んで、ビーコンかOTPコードのどちらで出席を取るかを選びます。受付中は、このページの一番上に出席の様子が出ます。</p>
      </div>

      {/* リアルタイム出席（受付中の回ごと。たためる）【2026-11-02】
          スマホのアプリで始めた受付も 10 秒以内にここに出る */}
      {liveItems.map(it => <LiveAttendancePanel key={it.key} item={it} />)}

      <AttendanceStartCard user={user} classes={classes} onClassChange={onStartClass} onActiveChange={setActive} />

      {/* 打刻できなかった学生を、その場で先生が記録する【2026-10-13】 */}
      <div id="manual" ref={manualRef} style={{ scrollMarginTop: '1rem' }}>
        <ManualAttendanceQuick classes={classes} suggestedClassId={startClassId} />
      </div>

      {/* 毎回は読まないので、たたんでおく【2026-11-02】 */}
      <details className="card otp-compare" style={{ background: '#f9fafb' }}>
        <summary className="otp-compare-summary">ビーコンとOTPコードの違い</summary>
        <table className="data-table">
          <thead>
            <tr><th>　</th><th>ビーコン（BLE）</th><th>OTPコード</th></tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>打刻のしかた</strong></td>
              <td>学生のアプリが教室のビーコンを検知して自動で打刻</td>
              <td>黒板やスクリーンに出した6桁を学生が入力</td>
            </tr>
            <tr>
              <td><strong>教室の外から</strong></td>
              <td>電波が届かないので打てない</td>
              <td><strong>番号を知っていれば打てる</strong></td>
            </tr>
            <tr>
              <td><strong>必要なもの</strong></td>
              <td>教室のビーコンと、教員アカウントへのビーコン割り当て</td>
              <td>なし</td>
            </tr>
            <tr>
              <td><strong>終わり方</strong></td>
              <td>手動で終了、または自動終了（既定90分後）</td>
              <td>有効時間が過ぎると失効。手動で無効化も可</td>
            </tr>
            <tr>
              <td><strong>向いている場面</strong></td>
              <td>ふだんの授業</td>
              <td>ビーコンが無い教室、ビーコンの不調時</td>
            </tr>
          </tbody>
        </table>
        <p style={{ fontSize: '0.85rem', color: '#4b5563', lineHeight: 1.8, marginTop: '0.8rem' }}>
          どちらも遅刻の判定は同じ基準です。授業ごとの遅刻のしきい値は
          「授業スケジュール」で設定します。
          OTPは教員が配るものなので、受付時間の外でも出席として記録します。
        </p>
      </details>
    </div>
  );
}
